import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Navigation from '../components/common/Navigation';
import TrustWealthLogo from '../components/TrustWealthLogo';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

export default function PendingApproval() {
  const { currentUser } = useAuth();

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      <section className="relative pt-24 pb-12 lg:pt-28 lg:pb-16 bg-[#0a1628]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-block">
            <TrustWealthLogo />
          </div>
          <p className="mt-4 text-primary-400 text-sm font-semibold tracking-widest uppercase">Account status</p>
          <h1 className="mt-2 font-serif text-2xl sm:text-3xl font-bold text-white">
            Account pending approval
          </h1>
        </div>
      </section>

      <section className="py-12 lg:py-16 bg-slate-50">
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-amber-100 rounded-full">
                <svg className="h-10 w-10 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <p className="text-lg font-medium text-slate-900 text-center mb-2">
              Thank you for registering with Willowvale Credit Union
            </p>
            <p className="text-slate-600 text-center text-sm mb-8">
              Your account is under review. We’ll notify you at <span className="font-medium text-slate-700">{currentUser?.email}</span> once it’s approved (typically 1–2 business days).
            </p>

            <div className="border-t border-slate-200 pt-6">
              <h3 className="text-sm font-semibold text-slate-900 mb-3">What happens next?</h3>
              <ul className="space-y-3">
                {[
                  'We’ll review your application and verify your information.',
                  'You’ll receive an email when your account is approved.',
                  'Then you can sign in and use your account.',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircleIcon className="h-5 w-5 text-primary-500 shrink-0 mt-0.5" />
                    <span className="text-sm text-slate-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-6 pt-6 border-t border-slate-200 text-center text-sm text-slate-600">
              Questions? Contact us at{' '}
              <a href="mailto:support@willowvalecu.com" className="font-medium text-primary-600 hover:text-primary-700">
                support@willowvalecu.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
